import * as S from './styles';

export default {
    name: 'CustomDropdown',
    props: {},
    data() {
        return {};
    },
    watch: {},
    computed: {},
    methods: {},
    render() {
        return <S.ComponentWrapper ref="dropboxWrapper"></S.ComponentWrapper>;
    },
};
